import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/.pnpm/@fontsource+roboto@5.0.13/node_modules/@fontsource/roboto/300.css");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/.pnpm/@fontsource+roboto@5.0.13/node_modules/@fontsource/roboto/400.css");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/.pnpm/@fontsource+roboto@5.0.13/node_modules/@fontsource/roboto/500.css");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/.pnpm/@fontsource+roboto@5.0.13/node_modules/@fontsource/roboto/700.css");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/usr/src/app/packages/administration_next/src/app/[locale]/providers.tsx");
